import {
  GraphQLSchema, GraphQLObjectType, GraphQLString, GraphQLBoolean, GraphQLList, GraphQLNonNull,
} from 'graphql';

const SkillsListType = new GraphQLObjectType({
  name: 'SkillsList',
  description: "Skills everywhere",
  fields: {
    skills: { type: new GraphQLList(GraphQLString), description: "List of skills" },
  },
});

const SkillType = new GraphQLObjectType({
  name: 'Skill',
  description: "Skills everywhere",
  fields: {
    skill: { type: GraphQLString, description: "Skill name" },
    level: { type: GraphQLString, description: "Level based on how often I use those, in work or personal projects" },
  },
});

const EmailResponseType = new GraphQLObjectType({
  name: 'EmailResponse',
  description: "Response from email server",
  fields: {
    sent: { type: GraphQLBoolean, description: "If it was sent" },
    msg: { type: GraphQLString, description: "An informative message" },
  },
});

const MeType = new GraphQLObjectType({
  name: 'My',
  description: "Personal information",
  fields: {
    name: { type: GraphQLString, description: "My name" },
    age: { type: GraphQLString, description: "My age" },
    email: { type: GraphQLString, description: "My email" },
    location: { type: GraphQLString, description: "Where am I now?" },
    github: { type: GraphQLString, description: "My Github page" },
    linkedin: { type: GraphQLString, description: "My Linkedin page" },
    employed: { type: GraphQLBoolean, description: "Am I employed right now?" },
  },
});

const HardSkillsType = new GraphQLObjectType({
  name: 'HardSkills',
  description: "Technical skills to fight in the world of IT(Information Technology...not the movie ofc)",
  fields: {
    skillLevelRange: { type: GraphQLString, description: "Skill scale" },
    frontend: { type: new GraphQLList(SkillType), description: "Frontend Skills" },
    backend: { type: new GraphQLList(SkillType), description: "Backend Skills" },
    devops: { type: new GraphQLList(SkillType), description: "DevOPs Skills" },
  },
});

const JobsType = new GraphQLObjectType({
  name: 'Jobs',
  description: "Working experience",
  fields: {
    company: { type: GraphQLString, description: "Name of the Company" },
    location: { type: GraphQLString, description: "Where is this Company located?" },
    website: { type: GraphQLString, description: "Company's Website" },
    role: { type: GraphQLString, description: "Role I had there" },
    started: { type: GraphQLString, description: "My journey started in" },
    finished: { type: GraphQLString, description: "My journey ended in" },
  },
});

const CreateMessageType = new GraphQLObjectType({
  name: 'CreateMessage',
  description: 'Feel free to send me a message',
  fields: {
    createMessage: {
      description: 'Use to create your message',
      type: EmailResponseType,
      args: {
        clientEmail: { type: new GraphQLNonNull(GraphQLString), description: 'Your email, so I can reply to you as soon as possible' },
        subject: { type: new GraphQLNonNull(GraphQLString), description: "An introduction that identifies your message intention" },
        message: { type: new GraphQLNonNull(GraphQLString), description: "Anything you want to say" },
      },
    },
  },
});

const GraphQLRoot = new GraphQLObjectType({
  name: 'Root',
  description: 'Things you can explore!',
  fields: {
    my: {
      description: "Personal information",
      type: new GraphQLNonNull(MeType),
    },
    softSkills: {
      description: "Attributes earned by the opinion of closed friends and family, over the years",
      type: new GraphQLNonNull(SkillsListType),
    },
    hardSkills: {
      description: "Technical skills to fight in the world of IT(Information Technology...not the movie ofc)",
      type: new GraphQLNonNull(HardSkillsType),
    },
    secondarySkills: {
      description: "\"Shutdown my brain\" activities",
      type: new GraphQLNonNull(SkillsListType),
    },
    jobs: {
      description: "Working experience",
      type: new GraphQLNonNull(JobsType),
    },
  },
});

const Schema = new GraphQLSchema({
  query: GraphQLRoot,
  mutation: CreateMessageType,
});

export default Schema;
